/* eslint-disable react/prop-types */
import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Badge, Icon, TableCell, TableRow } from "@tremor/react";
import { XCircleIcon } from "@heroicons/react/24/outline";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/solid";
import { getProfiles } from "../../store/admin/thunks";
import { DeleteModal, TableComponent, TitleTablePage } from "../components";
import { getNameProfile, getPermission } from "../helpers";
import { Spinner } from "../../ui";
import { MenuLayout } from "../layouts";
import { useAPI } from "../../hooks";

const headers = ["Nombre de Perfil", "Permiso en", "Permisos", "Acciones"];
//TODO: This isnt the best way to do it xd
const RowTable = ({ id, name, profiles = [], dispatch }) => {
  const [showModal, setModal] = useState(false);
  const { del } = useAPI();
  const navigate = useNavigate();
  const goToEdit = () => {
    navigate(`/admin/profile/${id}`);
  };

  const showModalDelete = () => {
    setModal(true);
  };

  const closeModalDelete = () => {
    setModal(false);
  };

  const deleteProfile = async () => {
    const resp = await del(`/profile/${id}`);
    closeModalDelete();
    dispatch(getProfiles());
  };
  return (
    <>
      {showModal && (
        <DeleteModal
          information={`${name}`}
          cancelFunction={closeModalDelete}
          confirmFunction={deleteProfile}
        />
      )}
      <TableRow>
        <TableCell>{name}</TableCell>

        <TableCell>
          {profiles.map((p) => {
            return (
              <Fragment key={`${id}-${p.name}`}>
                <p className="text-base mt-1">{getNameProfile(p.name)}</p>
              </Fragment>
            );
          })}
        </TableCell>
        <TableCell>
          {profiles.map((p) => (
            <Fragment key={`${id}-${p.name}`}>
              <div className="mt-1">
                {p.permissions.map((perm) => (
                  <Badge
                    key={`${id}-${perm.id}`}
                    icon={XCircleIcon}
                    className="hover:bg-sky-700 mx-1"
                  >
                    {getPermission(perm.name)}
                  </Badge>
                ))}
              </div>
            </Fragment>
          ))}
        </TableCell>
        <TableCell>
          <Icon variant="solid" icon={PencilSquareIcon} onClick={goToEdit} />
          <Icon
            variant="solid"
            icon={TrashIcon}
            className="ml-1"
            onClick={showModalDelete}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export const ProfilesTablePage = () => {
  const dispatch = useDispatch();
  const {
    profiles = [],
    hasError,
    messageError,
  } = useSelector((state) => state.admin);

  const tableContent = profiles.map((d) => (
    <RowTable key={d.id} {...d} dispatch={dispatch} />
  ));
  useEffect(() => {
    dispatch(getProfiles());
  }, [dispatch]);

  return (
    <>
      <MenuLayout hasError={hasError} messageError={messageError}>
        <TitleTablePage
          title="Perfiles"
          titleBtn="Crear Perfil"
          urlToGo="admin/profile"
        />
        {profiles.length > 0 ? (
          <TableComponent
            button=""
            showSelectLogs={true}
            showSearchInput={true}
            tableHeaders={headers}
            tableContent={tableContent}
            title="Perfiles Registrados"
          />
        ) : (
          <Spinner />
        )}
      </MenuLayout>
    </>
  );
};
